import InfiniteScroll from 'react-infinite-scroll-component';
import { ChatMessageType } from '../../../../libs/models/ChatMessage';
import { useAppSelector } from '../../../../redux/app/hooks';
import { RootState } from '../../../../redux/app/store';
import { IConversationDisplayMode } from '../../../../redux/features/app/AppState';
import { Conversations } from '../../../../redux/features/conversations/ConversationsState';
import { ChatListItem } from './ChatListItem';

interface IChatListSectionProps {
    onSelectChat: () => void;
    header?: string;
    conversations: Conversations;
    fetchData?: () => void;
    hasMore?: boolean;
}

export const ChatListSection: React.FC<IChatListSectionProps> = ({
    onSelectChat,
    header,
    conversations,
    fetchData,
    hasMore,
}) => {
    const { selectedId } = useAppSelector((state: RootState) => state.conversations);
    const { conversationDisplayMode } = useAppSelector((state: RootState) => state.app);
    const keys = Object.keys(conversations);
    const hasNonHiddenConversations = keys.some((id) => !conversations[id].hidden);
    const hasHiddenConversations = keys.some((id) => conversations[id].hidden);

    return keys.length > 0 && fetchData && hasMore !== undefined ? (
        <div className="flex flex-col pb-1">
            {(conversationDisplayMode === IConversationDisplayMode.All ||
                (conversationDisplayMode === IConversationDisplayMode.Active && hasNonHiddenConversations) ||
                (conversationDisplayMode === IConversationDisplayMode.Hidden && hasHiddenConversations)) && (
                <div className="text-primary-300 font-bold text-lg p-1 mb-2">{header}</div>
            )}
            <InfiniteScroll
                dataLength={keys.length}
                next={fetchData}
                hasMore={hasMore}
                scrollableTarget="chat-list"
                loader={null}>
                {keys.map((id) => {
                    const convo = conversations[id];
                    let lastMessage;
                    let preview = undefined;
                    if (convo.messages) {
                        lastMessage = convo.messages[convo.messages.length - 1];
                        preview =
                            convo.messages.length > 0
                                ? lastMessage.type === ChatMessageType.Document
                                    ? 'Sent a file'
                                    : lastMessage.type === ChatMessageType.Plan
                                      ? 'Click to view proposed plan'
                                      : lastMessage.content
                                : 'Click to start the chat';
                    }

                    //if (!convo.isSaved) return null;

                    const isSelected = id === selectedId;
                    const chatListItem = (
                        <ChatListItem
                            id={id}
                            key={id}
                            isSelected={isSelected}
                            onSelectChat={onSelectChat}
                            header={convo.title}
                            timestamp={convo.lastUpdatedTimestamp ?? lastMessage?.timestamp ?? 0}
                            recentAutoRename={convo.recentAutoRename ?? false}
                            preview={preview}
                            isHidden={convo.hidden ?? false}
                            scope={convo.chatScope}
                        />
                    );

                    if (
                        (conversationDisplayMode === IConversationDisplayMode.Active && !convo.hidden) ||
                        (conversationDisplayMode === IConversationDisplayMode.Hidden && convo.hidden)
                    ) {
                        return chatListItem;
                    } else if (conversationDisplayMode === IConversationDisplayMode.All) {
                        return chatListItem;
                    } else {
                        return null;
                    }
                })}
            </InfiniteScroll>
        </div>
    ) : null;
};
